import _ from 'lodash';

import urls from '../../../../src/urls';
import { route } from '../../../../src/routes/helpers';
import { DelayRepayPages } from '../../../../src/constants/AppConstants';
import DelayRepayStore from '../../stores/DelayRepayStore';

export function redirectToCorrectStage (nextState, replace) {
    const routeName = _.last(nextState.routes).name;

    if (routeName === DelayRepayPages.CONFIRM) {
        if (!DelayRepayStore.hasSubmittedClaims()) {
            replace(urls.location(DelayRepayPages.CUSTOMER));
        }
    } else if (!routeName) {
        // hack - redirected to unknown route (e.g. logout)
        replace(urls.location(DelayRepayPages.CUSTOMER));
    } else if (!DelayRepayStore.hasValidCustomerDetails()) {
        const validRoutes = [ DelayRepayPages.CUSTOMER ];
        if (!validRoutes.includes(routeName)) {
            replace(urls.location(DelayRepayPages.CUSTOMER));
        }
    } else if (!DelayRepayStore.hasValidClaims()) {
        const validRoutes = [ DelayRepayPages.CUSTOMER, DelayRepayPages.CLAIMS ];
        if (!validRoutes.includes(routeName)) {
            replace(urls.location(DelayRepayPages.CLAIMS));
        }
    } else if (!DelayRepayStore.hasValidPayment()) {
        const validRoutes = [ DelayRepayPages.CUSTOMER, DelayRepayPages.CLAIMS, DelayRepayPages.PAYMENT ];
        if (!validRoutes.includes(routeName)) {
            replace(urls.location(DelayRepayPages.PAYMENT));
        }
    }
}

export function delayRepayRoute (name, options = {}) {
    return route(name, {
        ...options,
        onEnter (nextState, replace) {
            redirectToCorrectStage(nextState, replace);
        }
    });
}
